<template>
  <footer class="container-fluid Section Section--footer">
    <div class="container">
      <div class="row">
        <div class="col-sm-3 text-center text-sm-left">
          <a href="https://ideum.com" target="_blank" rel="noopener" title="Ideum.com">
            <svg 
              version="1.1" 
              id="svg-logo-footer" 
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink" 
              x="0px" y="0px" 
              viewBox="0 0 223 84" 
              class="Section--footer-logo"
              style="enable-background:new 0 0 223 84;" 
              xml:space="preserve">
            <g id="XMLID_93_">
              <path id="XMLID_113_" class="st0" d="M73.7,27.6v55.3h-13v-5.4c-1.8,2.3-3.5,3.8-5,4.6c-2,1-4.2,1.6-6.7,1.6
                c-4.9,0-8.7-1.9-11.3-5.6c-2.6-3.8-3.9-8.3-3.9-13.7c0-6,1.4-10.6,4.3-13.8c2.9-3.2,6.5-4.8,11-4.8c2.2,0,4.1,0.4,5.9,1.1
                c1.8,0.7,3.3,1.8,4.7,3.3V27.6H73.7z M59.8,64.7c0-2.8-0.6-5-1.8-6.4c-1.2-1.4-2.7-2.1-4.6-2.1c-1.6,0-3,0.7-4.1,2
                c-1.1,1.3-1.6,3.6-1.6,6.8c0,3,0.6,5.1,1.7,6.5c1.1,1.4,2.5,2.1,4.2,2.1c1.8,0,3.3-0.7,4.4-2.1C59.2,70.1,59.8,67.8,59.8,64.7z"/>
              <path id="XMLID_109_" class="st0" d="M118.3,68.2H90.4c0.3,2.2,0.9,3.9,1.8,5c1.3,1.6,3.1,2.4,5.3,2.4c1.4,0,2.7-0.3,3.9-1
                c0.8-0.4,1.6-1.2,2.4-2.3l13.7,1.3c-2.1,3.6-4.6,6.3-7.6,7.8c-3,1.6-7.2,2.4-12.7,2.4c-4.8,0-8.6-0.7-11.3-2
                c-2.8-1.4-5-3.5-6.8-6.5c-1.8-2.9-2.7-6.4-2.7-10.4c0-5.7,1.8-10.3,5.4-13.8c3.6-3.5,8.6-5.3,15-5.3c5.2,0,9.3,0.8,12.3,2.4
                c3,1.6,5.3,3.8,6.9,6.8c1.6,3,2.4,6.9,2.4,11.6V68.2z M104.1,61.6c-0.3-2.7-1-4.6-2.2-5.8c-1.2-1.2-2.7-1.7-4.6-1.7
                c-2.2,0-4,0.9-5.3,2.6c-0.8,1.1-1.4,2.7-1.6,4.9H104.1z"/>
              <path id="XMLID_105_" class="st0" d="M158.9,82.9h-13V77c-1.9,2.4-3.9,4.1-5.9,5.2c-2,1-4.4,1.5-7.3,1.5c-3.8,0-6.8-1.1-9-3.4
                c-2.2-2.3-3.3-5.8-3.3-10.6V46.7h14v19.9c0,2.3,0.4,3.9,1.3,4.8c0.8,1,2,1.4,3.5,1.4c1.7,0,3-0.6,4.1-1.9c1.1-1.3,1.6-3.6,1.6-6.9
                V46.7h13.9V82.9z"/>
              <path id="XMLID_102_" class="st0" d="M161.5,46.7h13v5.3c1.9-2.2,3.8-3.8,5.7-4.7c1.9-0.9,4.2-1.4,6.9-1.4c2.9,0,5.2,0.5,6.9,1.5
                c1.7,1,3.1,2.5,4.1,4.6c2.2-2.4,4.2-4,6-4.8c1.8-0.9,4-1.3,6.6-1.3c3.9,0,6.9,1.2,9.1,3.5c2.2,2.3,3.3,5.9,3.3,10.8v22.8h-13.9
                V62.2c0-1.6-0.3-2.9-1-3.7c-0.9-1.3-2.1-1.9-3.5-1.9c-1.6,0-2.9,0.6-3.9,1.8c-1,1.2-1.5,3.1-1.5,5.7v18.7h-13.9v-20
                c0-1.6-0.1-2.7-0.3-3.2c-0.3-0.9-0.8-1.6-1.5-2.2c-0.7-0.6-1.6-0.8-2.6-0.8c-1.6,0-2.9,0.6-3.9,1.8c-1,1.2-1.5,3.2-1.5,5.9v18.5
                h-13.9V46.7z"/>
              <g id="XMLID_97_">
                <circle id="XMLID_24_" class="st0" cx="24.4" cy="33.6" r="7.7"/>
                <g id="XMLID_98_">
                  <circle id="XMLID_21_" class="st0" cx="24.4" cy="33.6" r="7.7"/>
                  <path id="XMLID_20_" class="st0" d="M17.6,43.2v39.7h13.9V43c-2,1.5-4.4,2.3-7,2.3C21.9,45.4,19.5,44.6,17.6,43.2z"/>
                </g>
              </g>
              <rect id="XMLID_17_" x="22.8" y="0.3" class="st0" width="3.3" height="19"/>
              
                <rect id="XMLID_11_" x="6.2" y="7.2" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -9.5262 10.4465)" class="st0" width="3.3" height="19"/>
              
                <rect id="XMLID_5_" x="39.3" y="7.2" transform="matrix(-0.7071 -0.7071 0.7071 -0.7071 58.0609 57.4945)" class="st0" width="3.3" height="19"/>
            </g>
            </svg>
          </a>
          <p class="Section--footer-legal">&copy; Ideum. All rights reserved.</p>
        </div>

        <div class="col-sm-3 d-flex flex-column justify-content-center mb-4 mb-sm-0 ml-auto text-center text-sm-left">
          <ul class="Section--footer-list">
            <li>
              <a href="https://ideum.com/support" target="_blank" title="Ideum Support" rel="noopener">
                Support
              </a>
            </li>
            <li>
              <a href="https://ideum.com/legal" target="_blank" title="Ideum Privacy &amp; Legal Terms" rel="noopener">
                Privacy &amp; Terms
              </a>
            </li>
          </ul>
        </div>

        <div class="col-sm-4 col-md-2 d-flex flex-column justify-content-center mx-auto text-center text-sm-left">
          <h3 class="Section--footer-heading">Follow Us</h3>
          <ul class="Section--footer-list">
            <li class="Section--footer-list-item">
              <a href="https://www.facebook.com/ideum/" target="_blank" title="Ideum on Facebook" rel="noopener">
                <icon name="facebook-square" scale="1.5"/>
              </a>
            </li>
            <li class="Section--footer-list-item">
              <a href="https://www.flickr.com/photos/ideum/" target="_blank" title="Ideum on Flickr" rel="noopener">
                <icon name="flickr" scale="1.5"/>
              </a>
            </li>
            <li class="Section--footer-list-item">
              <a href="https://www.instagram.com/ideum/" target="_blank" title="Ideum on Instagram" rel="noopener">
                <icon name="instagram" scale="1.5"/>
              </a>
            </li>
            <li class="Section--footer-list-item">
              <a href="https://www.linkedin.com/company/ideum/" target="_blank" title="Ideum on LinkedIn" rel="noopener">
                <icon name="linkedin-square" scale="1.5"/>
              </a>
            </li>
            <li class="Section--footer-list-item">
              <a href="https://twitter.com/ideum?lang=en" target="_blank" title="Ideum on Twitter" rel="noopener">
                <icon name="twitter-square" scale="1.5"/>
              </a>
            </li>
            <li class="Section--footer-list-item">
              <a href="https://www.youtube.com/user/multitouchexhibits/" target="_blank" title="Ideum on YouTube" rel="noopener">
                <icon name="youtube-square" scale="1.5"/>
              </a>
            </li>
            <!-- <li class="Section--footer-list-item">
              <a href="https://plus.google.com/+Ideum" target="_blank" title="Ideum on Google+" rel="noopener">
                <icon name="google-plus-square" scale="1.5"/>
              </a>
            </li> -->
            <li class="Section--footer-list-item">
              <a href="https://www.pinterest.com/ideum/" target="_blank" title="Ideum on Pinterest" rel="noopener">
                <icon name="pinterest-square" scale="1.5"/>
              </a>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/facebook-square'
import 'vue-awesome/icons/flickr'
import 'vue-awesome/icons/google-plus-square'
import 'vue-awesome/icons/instagram'
import 'vue-awesome/icons/linkedin-square'
import 'vue-awesome/icons/pinterest-square'
import 'vue-awesome/icons/twitter-square'
import 'vue-awesome/icons/youtube-square'
export default {
  components: {
    Icon
  }
}
</script>

<style lang="scss" scoped>
@import './../assets/_variables.scss';

.Section--footer {
  background-color: $colorMidnight;
  padding: 4em 0;
}

.Section--footer-heading {
  color: $colorEmerald;
}

.Section--footer-list {
  color: $colorWhite;
  font-family: $fontPrimary;
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-transform: uppercase;
  a {
    transition: $transitionPrimary;
    &:hover, &:active {
      color: $colorEmerald;
      text-decoration: none;
    }
    &:focus {
      outline: 0;
    }
  }
}

.Section--footer-list-item {
  display: inline-block;
  margin: 0 1em 0 0;
  &:last-child {
    margin: 0;
  }
}

.Section--footer-legal {
  color: $colorWhite;
  font-size: .8em;
}

.Section--footer-logo {
  cursor: pointer;
  fill: $colorWhite;
  margin: 0 0 1em 0;
  max-width: 160px;
  transition: $transitionPrimary;
  &:hover, &:active {
    fill: $colorEmerald;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue